(function() {
  'use strict';

  const spiralManager = {
    activeCanvases: new Set(),
    rafId: null,

    add(canvasData) {
      this.activeCanvases.add(canvasData);
      this.start();
    },

    remove(canvasData) {
      this.activeCanvases.delete(canvasData);
      if (this.activeCanvases.size === 0) this.stop();
    },

    start() {
      if (this.rafId) return;
      const loop = () => {
        if (document.hidden) {
          this.rafId = requestAnimationFrame(loop);
          return;
        }
        this.activeCanvases.forEach(c => {
          const { ctx, offscreen, speed } = c;
          const SIZE = ctx.canvas.width;
          ctx.clearRect(0, 0, SIZE, SIZE);
          ctx.save();
          ctx.translate(SIZE / 2, SIZE / 2);
          ctx.rotate(c.angle);
          ctx.drawImage(offscreen, -SIZE / 2, -SIZE / 2);
          ctx.restore();
          c.angle += speed;
        });
        this.rafId = requestAnimationFrame(loop);
      };
      this.rafId = requestAnimationFrame(loop);
    },

    stop() {
      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }
    }
  };

  window.initSlideshowAnimations = function(container) {
    if (!container) return;

    const starFills = ['#e981ab', '#4D509C', '#FCEDF1'];
    const starGroups = container.querySelectorAll('.stars-rising-group');
    starGroups.forEach(group => {
      if (group.dataset.starColorInit) return;
      group.dataset.starColorInit = 'true';

      const assignStarFill = (star) => {
        star.style.setProperty('--star-fill', starFills[Math.floor(Math.random() * starFills.length)]);
      };

      group.querySelectorAll('.star-rising').forEach(star => {
        assignStarFill(star);
        star.addEventListener('animationiteration', () => assignStarFill(star));
      });
    });

    const bubblesFields = container.querySelectorAll('.bubbles-field');
    bubblesFields.forEach(field => {
      if (field.dataset.bubbleInit) return;
      field.dataset.bubbleInit = 'true';

      const colors = [
        'rgba(255,255,255,0.55)',
        'rgba(200,230,255,0.45)',
        'rgba(255,220,240,0.45)',
        'rgba(220,255,220,0.40)',
        'rgba(255,245,200,0.45)'
      ];

      function createBubble() {
        const slide = field.closest('.swiper-slide');
        if (!slide || !slide.classList.contains('swiper-slide-active')) return;

        const b = document.createElement('div');
        b.className = 'bubble-rise';
        const size = 18 + Math.random() * 60;
        const leftPos = 5 + Math.random() * 90;
        const dur = 5 + Math.random() * 7;
        const sway = (Math.random() > 0.5 ? 1 : -1) * (20 + Math.random() * 40);
        const color = colors[Math.floor(Math.random() * colors.length)];
        const delay = Math.random() * 2;

        b.style.cssText = `width:${size}px;height:${size}px;left:${leftPos}%;bottom:-${size + 10}px;--sway:${sway}px;--dur:${dur}s;--delay:${delay}s;background:radial-gradient(circle at 35% 30%,rgba(255,255,255,0.85) 0%,${color} 45%,rgba(255,255,255,0.05) 100%);`;
        field.appendChild(b);
        setTimeout(() => b.parentNode && b.parentNode.removeChild(b), (dur + delay + 0.5) * 1000);
      }

      let spawnInterval;
      const startSpawning = () => {
        if (!spawnInterval) spawnInterval = setInterval(() => !document.hidden && createBubble(), 600);
      };
      const stopSpawning = () => {
        clearInterval(spawnInterval);
        spawnInterval = null;
      };

      const observer = new MutationObserver(() => {
        const slide = field.closest('.swiper-slide');
        if (slide && slide.classList.contains('swiper-slide-active')) startSpawning();
        else stopSpawning();
      });

      const parentSlide = field.closest('.swiper-slide');
      if (parentSlide) {
        observer.observe(parentSlide, { attributes: true, attributeFilter: ['class'] });
        if (parentSlide.classList.contains('swiper-slide-active')) startSpawning();
      }
    });

    const spiralWraps = container.querySelectorAll('.spiral-canvas-wrap');
    if (spiralWraps.length > 0) {
      const blocksWithSpirals = new Set();
      spiralWraps.forEach(wrap => blocksWithSpirals.add(wrap.id.split('-').pop()));

      const scheduleSpiral = (blockId) => {
        const doInit = () => initSpiralForBlock(blockId, container);
        if ('requestIdleCallback' in window) {
          requestIdleCallback(doInit, { timeout: 2000 });
        } else {
          setTimeout(doInit, 300);
        }
      };

      blocksWithSpirals.forEach(blockId => scheduleSpiral(blockId));
    }
  };

  function initSpiralForBlock(blockId, container) {
    const spirals = container.querySelectorAll(`.spiral-canvas-wrap[id*="-${blockId}"]`);
    if (spirals.length === 0 || spirals[0].dataset.spiralInit) return;
    spirals.forEach(s => s.dataset.spiralInit = 'true');

    const color  = spirals[0].dataset.color  || '#e8173a';
    const petals = parseInt(spirals[0].dataset.petals || '5', 10);
    const speed  = parseFloat(spirals[0].dataset.speed || '4') * 0.001;

    function hexToRgb(hex) {
      hex = hex.replace('#', '');
      if (hex.length === 3) hex = hex.split('').map(c => c + c).join('');
      const n = parseInt(hex, 16);
      return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
    }
    const rgb = hexToRgb(color);

    function preRenderSpiral(SIZE, k, rgb) {
      const offscreen = document.createElement('canvas');
      offscreen.width = SIZE;
      offscreen.height = SIZE;
      const ctx = offscreen.getContext('2d');
      const cx = SIZE / 2, cy = SIZE / 2, R = SIZE * 0.42, STEPS = 700;
      for (let i = 0; i < STEPS; i++) {
        const t = (i / STEPS) * Math.PI * 2;
        const r_curve = R * Math.abs(Math.cos(k * t));
        const px = cx + r_curve * Math.cos(t);
        const py = cy + r_curve * Math.sin(t);
        const cf = Math.abs(Math.cos(k * t));
        ctx.beginPath();
        ctx.arc(px, py, 1.5 + cf * 5.5, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(${rgb[0]},${rgb[1]},${rgb[2]},${(0.06 + cf * 0.20)})`;
        ctx.fill();
      }
      return offscreen;
    }

    const firstWrap = spirals[0];
    const SIZE = Math.min(firstWrap.offsetWidth || 150, firstWrap.offsetHeight || 150, 150);
    const offscreen = preRenderSpiral(SIZE, petals, rgb);

    const canvases = [];
    spirals.forEach(wrap => {
      const type = wrap.id.split('-')[1];
      let phaseOffset = 0;
      if (type === 'tr') phaseOffset = Math.PI * 0.4;
      if (type === 'bl') phaseOffset = Math.PI * 0.8;
      if (type === 'br') phaseOffset = Math.PI * 1.2;

      const canvas = document.createElement('canvas');
      canvas.width = SIZE;
      canvas.height = SIZE;
      canvas.style.cssText = `width:${SIZE}px;height:${SIZE}px`;
      wrap.appendChild(canvas);

      canvases.push({
        ctx: canvas.getContext('2d', { alpha: true }),
        offscreen,
        angle: phaseOffset,
        speed
      });
    });

    const parentSlide = spirals[0].closest('.swiper-slide');
    if (parentSlide) {
      const observer = new MutationObserver(() => {
        if (parentSlide.classList.contains('swiper-slide-active')) {
          canvases.forEach(c => spiralManager.add(c));
        } else {
          canvases.forEach(c => spiralManager.remove(c));
        }
      });
      observer.observe(parentSlide, { attributes: true, attributeFilter: ['class'] });
      if (parentSlide.classList.contains('swiper-slide-active')) {
        canvases.forEach(c => spiralManager.add(c));
      }
    } else {
      canvases.forEach(c => spiralManager.add(c));
    }
  }

  const init = () => {
    document.querySelectorAll('.slideshow-section').forEach(s => window.initSlideshowAnimations(s));
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => init(), { timeout: 3000 });
  } else {
    setTimeout(init, 500);
  }

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.classList.contains('slideshow-section')) {
      window.initSlideshowAnimations(e.target);
    }
  });

})();
